import React from 'react';

import { slugify } from '@digital-spiders/misc-utils';
import { openTermsModal } from '../../stores/termsModalOpenStore';
import type { RawPortableText } from '../../types/types';
import type { FormField, FormFieldWithId, FormSubmitAction } from './Form';
import Form from './Form';
import TextLink from './TextLink';

export interface FormWrapperProps {
  className?: string;
  form: {
    fields: Array<FormField>;
    submitButtonText?: string;
    onSubmitActions?: Array<FormSubmitAction>;
    thankYouScreen: {
      title: string;
      subtitle?: string;
      _rawText?: RawPortableText;
    };
  };
}

const FormWrapper = ({ form, className }: FormWrapperProps): React.ReactElement => {
  const additionalFormFields = [
    {
      crmFieldId: 'acceptTheTerms',
      fieldType: 'singleCheckbox',
      isFieldRequired: true,
      textNode: (
        <p>
          I agree to the{' '}
          <TextLink
            styleOnly
            onClick={e => {
              e.preventDefault();
              openTermsModal();
            }}
          >
            terms and conditions
          </TextLink>{' '}
        </p>
      ),
      labelAsText: 'I agree to the terms and conditions',
    },
    {
      crmFieldId: 'joinTheHookPointNewsletter',
      fieldType: 'singleCheckbox',
      isFieldRequired: false,
      textNode: <p>Join The Going Viral Newsletter!</p>,
      labelAsText: 'Join The Going Viral Newsletter!',
    },
  ] as Array<FormField>;

  const formFieldsWithIds: Array<FormFieldWithId> = [...form.fields, ...additionalFormFields].map(
    formField => ({
      id: slugify(
        formField.fieldType === 'singleCheckbox' ? formField.labelAsText : formField.title,
      ),
      ...formField,
    }),
  );

  return (
    <Form
      formType="contact"
      fields={formFieldsWithIds}
      submitButtonText={form.submitButtonText}
      onSubmitActions={form.onSubmitActions}
      thankYouScreen={form.thankYouScreen}
      className={className}
    />
  );
};

export default FormWrapper;
